export const REPORT_LOST_CARD_ERROR = 'report lost card error'
export const REPLACE_CARD_ERROR = 'replace card error'
